<template>
    <div class="collapse-item">

        <div class="title-wrapper" :class="{collapsed}" @click="collapsed = !collapsed">
            <div class="title-container">
                <slot name="title">
                    <CO_FAQ class="icon"/><div class="title">{{ title }}</div>
                </slot>
            </div>
            <div class="collapse-arrow" :class="{collapsed}" @click.stop="collapsed = !collapsed">
                <icon-up></icon-up>
            </div>
        </div>

        <transition name="fade">
            <div class="content-wrapper" v-show="!collapsed">
                <div class="icon-wrapper">
                    <div style="width: 20px;height:20px;"></div>
                    <!-- <CO_COMMENT class="icon"/> -->
                </div>
                <slot>
                    <div class="content">{{ content }}</div>
                </slot>
            </div>
        </transition>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import IconUp from '../Svg/IconUp.vue';
import CO_FAQ from '../Svg/CO_FAQ.vue';
// import CO_COMMENT from '../Svg/CO_COMMENT.vue';
import CommentSvg from '@/common/images/common/combo/co_comment.svg';
import FaqSvg from '@/common/images/common/combo/co_faq.svg';

export default Vue.extend({
    name: 'CollapseItem',
    components: {
        IconUp,
        CO_FAQ,
        // CO_COMMENT
    },
    props: {
        id: Number,
        title: String,
        content: String,
        accordion: Boolean,
        currentActive: Number,
        defaultActive: {
            type: Number,
            default: 0
        },
    },
    data() {

        return {
            FaqSvg,
            CommentSvg,
            collapsed: this.defaultActive !== this.id
        };

    },
    watch: {
        currentActive( newVal: number ) {

            if ( this.accordion ) {

                if ( this.id === newVal ) {

                    this.collapsed = false;

                } else {

                    this.collapsed = true;

                }

            }

        },
        collapsed( newVal ) {

            this.$emit( 'collapsed', newVal, this.id );

        }
    }
});
</script>

<style lang="less">
    .collapse-item{
        position: relative;
        padding: 20px 16px;
        background-color: @bg_02;
        font-size: 16px;
        font-weight: 500;
        font-family: @font_02;
        color: @font_primary;
        border-radius: 8px;
        &:not(:first-child){
            margin-top: 20px;
        }
        @media @mobile{
            font-size: 14px;
        }
        .title-wrapper{
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            .title-container{
                display: flex;
                column-gap: 10px;
            }
            .collapse-arrow{
                display: inline-flex;
                transition: all 0.3s ease;
                &.collapsed{
                    transform: rotate(-180deg);
                }
                @media @mobile{
                    svg{
                        width: 20px;
                        height: 20px;
                    }
                }
            }
        }
        .content-wrapper{
            padding-top: 16px;
            display: flex;
            column-gap: 10px;
            border-top: 1px solid @line;
            margin-top: 16px;
        }
        .icon{
            color: @theme;
        }
    }
</style>
